module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/trapezeartist.d346f90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/trapezeartist.jpg
// module id = iCo9
// module chunks = 0